import React, { useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import Carousel from 'react-bootstrap/Carousel';
import CircularLoader from 'utils/loader/circular-loader';
import './styles.css';

import { withAuthorization } from '../Session';
import { getSliderImages } from '../../store/dashboard/action';
import AllGCList from '../GiftCards/all-gc-list';

import styles from './index.module.scss';

function Dashboard(props) {
    const dispatch = useDispatch();
    const role = localStorage.getItem('WitchloginAs')?.toLowerCase();

    useEffect(() => {
        // fetchADashboardStatics();
        dispatch(getSliderImages());
    }, []);

    if (props.loading) {
        return (
            <div className={styles.loader}>
                <CircularLoader />
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            {role !== 'admin' && role !== 'gmanager' ? (
                <Carousel className={styles.carousel}>
                    {props.sliderImages?.map((row, index) => (
                        <Carousel.Item key={row.name}>
                            <img
                                className="d-block w-100"
                                src={row.url}
                                alt={row.name + ' indiabuys-post'}
                                height="400rem"
                            />
                        </Carousel.Item>
                    ))}
                </Carousel>
            ) : null}
            <AllGCList />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.dashboard.loading,
        sliderImages: state.dashboard.sliderImages
    };
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(
    connect(mapStateToProps, null)(Dashboard)
);
